// eslint-disable-next-line no-unused-vars
import {executeQuery} from "@/main";
import generateInformativeScorePdf from 'raw-loader!./graphql/mutation/generateInformativeScorePdf.graphqls';
import upsertInformativeScore from 'raw-loader!./graphql/mutation/upsertInformativeScore.graphqls';
import shareInformativeScorePdf from 'raw-loader!./graphql/mutation/shareInformativeScorePdf.graphqls';
import sendInformativeScoreToken from 'raw-loader!./graphql/mutation/sendInformativeScoreToken.graphqls';
import insertFeedback from 'raw-loader!./graphql/mutation/insertFeedback.graphqls';
import informativeScoreByUUID from 'raw-loader!./graphql/query/informativeScoreByUUID.graphqls';

export default class AppService {
    generateInformativeScorePdf(informativeScore) {
        return executeQuery(null, generateInformativeScorePdf, {informativeScore})
    }

    upsertInformativeScore(informativeScore) {
        return executeQuery(null, upsertInformativeScore, {informativeScore})
    }
    shareInformativeScorePdf(informativeScore, email) {
        return executeQuery(null, shareInformativeScorePdf, {informativeScore, email})
    }
    sendInformativeScoreToken(informativeScore, email) {
        return executeQuery(null, sendInformativeScoreToken, {informativeScore, email})
    }
    insertFeedback(feedback) {
        return executeQuery(null, insertFeedback, {feedback})
    }
    informativeScoreByUUID(uuid) {
        return executeQuery(null, informativeScoreByUUID, {uuid})
    }
}
